/**
 * @generated SignedSource<<34ad8ac5ffa495f3b9ce4da42ecc0c92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceDataTodoGallery_Workspace$data = {
  readonly gallery: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly store: {
          readonly id: string;
          readonly name: string;
          readonly timezone: string;
        } | null;
        readonly title: string;
        readonly " $fragmentSpreads": FragmentRefs<"WorkspaceDataTodoGalleryItem_todo">;
      };
      readonly score: number | null;
    }>;
    readonly matchingIssueClasses: ReadonlyArray<{
      readonly count: number;
      readonly label: string;
    }>;
  };
  readonly id: string;
  readonly " $fragmentType": "WorkspaceDataTodoGallery_Workspace";
};
export type WorkspaceDataTodoGallery_Workspace$key = {
  readonly " $data"?: WorkspaceDataTodoGallery_Workspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceDataTodoGallery_Workspace">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "gallery"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "issueClassFilter"
    },
    {
      "kind": "RootArgument",
      "name": "query"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./WorkspaceDataTodoGallery_Workspace_WorkspaceRefetchQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "WorkspaceDataTodoGallery_Workspace",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "gallery",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "requireImages": true,
            "requireTaskExecution": true
          }
        },
        {
          "kind": "Variable",
          "name": "issueClass",
          "variableName": "issueClassFilter"
        },
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query"
        }
      ],
      "concreteType": "WorkspaceStoreTodoConnection",
      "kind": "LinkedField",
      "name": "__WorkspaceDataTodoGallery_Workspace__gallery_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IssueClassResult",
          "kind": "LinkedField",
          "name": "matchingIssueClasses",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TodoEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "score",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Todo",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Store",
                  "kind": "LinkedField",
                  "name": "store",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "timezone",
                      "storageKey": null
                    },
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WorkspaceDataTodoGalleryItem_todo"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "1744cdabec5eb017b52351852912f529";

export default node;
